import { Alert } from '@creditornot/cb-alert';
import React from 'react';

import { CampaignType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

import getVenueAlertMessage from './venues-section/getVenueAlertMessage';
import { useCampaignModuleContext } from '../context';
import { useCampaignsList } from '../hooks/useCampaignsList';

type VenueCampaignOverlapAlertProps = {
  className?: string;
  campaignType: CampaignType;
  startDate: string;
  endDate: string;
};

export const VenueCampaignOverlapAlert = ({
  className,
  campaignType,
  startDate,
  endDate,
}: VenueCampaignOverlapAlertProps) => {
  const { entityType, venues, merchantId, timezone, country } = useCampaignModuleContext();
  const venueId = venues[0]?.id;
  const enabled = entityType === 'venue' && !!venueId;

  const { campaignsList, isCampaignsLoading } = useCampaignsList({
    merchantId,
    venueIds: venueId ? [venueId] : [],
    timezone,
    country,
    isMerchantLevel: false,
    enabled,
  });

  if (isCampaignsLoading || !enabled) {
    return null;
  }

  const campaignOverlapAlert = getVenueAlertMessage({
    venueId,
    campaignOverlapInfo: {
      existingCampaigns: campaignsList,
      newCampaignType: campaignType,
      newCampaignSchedule: { startDate, endDate },
    },
    inactiveVenuesIds: undefined,
    timezone,
  });

  if (!campaignOverlapAlert) {
    return null;
  }

  return (
    <Alert variant="info" size="small" className={className}>
      {campaignOverlapAlert}
    </Alert>
  );
};
